const statusTitles = {
  deleted: "Deleted",
  description: "Description", // Deprecated
  idea: "Idea",
  javascript: "JavaScript",
  pending: "Pending", // Deprecated
  published: "Publish",
  retest: "Retest", // Deprecated
  sandbox: "Sandbox", // Deprecated
  test: "Test",
  withdrawn: "Withdrawn",
};

const statusClasses = {
  deleted: "label-danger",
  description: "label-default", // Deprecated
  idea: "label-default",
  javascript: "label-primary",
  pending: "label-warning", // Deprecated
  published: "label-success",
  retest: "label-info", // Deprecated
  sandbox: "label-primary", // Deprecated
  test: "label-info",
  withdrawn: "label-danger",
};

const statusInfo = {
  deleted: "The script is deleted.",
  javascript: "Not published, or available for testing.",
  published: `The latest published version of the script will be included in all new data releases.
Any changes will need to be published to be included.`,
  test: "The script is available for testing, but it's not published and won't be included in new data releases.",
  withdrawn: "The script has been withdrawn and will not be included in new data releases, or testing.",
};

statusInfo.idea = statusInfo.javascript;

statusInfo.description = statusInfo.javascript;
statusInfo.pending = statusInfo.javascript;
statusInfo.retest = statusInfo.test;
statusInfo.sandbox = statusInfo.javascript;

export default angular
  .module("ScriptMetaCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ScriptMetaController", [
    "$scope",
    "$timeout",
    "$location",
    "$state",
    "$modal",
    "$stateParams",
    "$http",
    "$rootScope",
    "$translate",
    "Scripts",
    "Message",
    "System",
    "ScriptLoading",
    "modal",
    function (
      $scope,
      $timeout,
      $location,
      $state,
      $modal,
      $stateParams,
      $http,
      $rootScope,
      $translate,
      Scripts,
      Message,
      System,
      ScriptLoading,
      modal,
    ) {
      $scope.statusTitles = statusTitles;
      $scope.statusClasses = statusClasses;
      $scope.statusInfo = statusInfo;
      $scope.compatibilityModes = {
        all: "All",
        legacy: "EBMEDS v1 (legacy)",
        node: "EBMEDS v2 (node)",
      };

      System.loadContentProviders((data) => {
        $scope.contentproviders = data;
      });

      $scope.openChangeFieldModal = function (prev) {
        modal.createConfirmationModal(
          "Changing script type:",
          "Are you sure you want to change this?",
        )
          .result
          .then(({ action }) => {
            if (action === "confirm") {
              $scope.changedField("scriptmeta", "GLOBAL");
            }
          }).catch(() => {
            $scope.scriptmeta.GLOBAL = prev;
          }); // Selecting 'No' throws Exception
      };
      // open modal to edit regional usage
      $scope.openRegionalModal = function (script) {
        const modalInstance = $modal.open({
          animation: true,
          size: "lg",
          templateUrl: "view/modal/editRegionalUsage.html",
          backdrop: "static",
          controller: "ModifyRegionalUsageController",
          resolve: {
            scriptData() {
              return script;
            },
          },
        });
        modalInstance.result.then(() => {
        });
      };

      // open modal to show status history
      $scope.openStatusHistoryModal = function (script) {
        const modalInstance = $modal.open({
          animation: true,
          size: "lg",
          templateUrl: "view/modal/showStatusHistory.html",
          backdrop: "static",
          controller: "ShowStatusHistoryController",
          resolve: {
            scriptData() {
              return script;
            },
          },
        });
        modalInstance.result.then(() => {});
      };

      $scope.openAuditLog = function (scriptId) {
        const modalInstance = $modal.open({
          animation: true,
          size: "lg",
          templateUrl: "view/modal/showAuditLog.html",
          backdrop: "static",
          controller: "ShowAuditLogController",
          resolve: {
            resourceId() {
              return scriptId;
            },
          },
        });
        modalInstance.result.then(() => {});
      };

      // open modal to edit blocking
      $scope.openBlockingModal = function (script) {
        const modalInstance = $modal.open({
          animation: true,
          size: "lg",
          templateUrl: "view/modal/editBlockingUsage.html",
          backdrop: "static",
          controller: "ModifyBlockingController",
          resolve: {
            scriptData() {
              return script;
            },
          },
        });
        modalInstance.result.then(() => {
        });
      };

      // open modal to edit title translations
      $scope.openTitleTranslationModal = function (script) {
        const modalInstance = $modal.open({
          animation: true,
          size: "lg",
          templateUrl: "view/modal/editTitleTranslation.html",
          backdrop: "static",
          controller: "ModifyTitleTranslationController",
          resolve: {
            scriptData() {
              return script;
            },
          },
        });
        modalInstance.result.then(() => {
          Scripts.loadScriptTitlesByID(
            script.ID,
            $rootScope.loggedUser.language,
            (data, status) => {
              $scope.titles = data;
              if (status === 200) {
                ScriptLoading.markMetadataResourceLoaded("scriptTitles");
              }
            },
          );
        });
      };

      // load evidence for ngtags form element in modal window.
      $scope.loadEvidenceTags = function () {
        return $http.get("/api/systemevidence/");
      };

      const triggers = [
        "ActiveDiagnosis",
        "CloseRecord",
        "Demand",
        "NewConsultation",
        "NewDiagnosis",
        "NewDrug",
        "NewForm",
        "NewProcedure",
        "OpenRecord",
        "View",
        "VirtualHealthCheck",
      ].map(trigger => `on${trigger}`); // eg. onView

      const metaFields = triggers.map(trg => trg.toUpperCase());

      const arrayToColumns = (array, columnCount) => {
        const itemsPerColumn = Math.ceil(array.length / columnCount);

        const columns = [];
        for (let i = 0; i < array.length; i += itemsPerColumn) {
          columns.push(array.slice(i, i + itemsPerColumn));
        }
        return columns;
      };

      $scope.triggerColumns = arrayToColumns(triggers, 3);

      $scope.isOnAllEvents = () =>
        !metaFields.some(trg => $scope.scriptmeta[trg] === "T");

      $scope.toggleAll = () => {
        const newValue = $scope.isOnAllEvents() ? "T" : "F";

        metaFields.forEach((trg) => {
          $scope.scriptmeta[trg] = newValue;
        });
        $scope.changedField("scriptmeta");
      };

      // Save changes to script. User clicked save changes -button in left menu
      // after modifying script.
      const scriptListener = $rootScope.$on("saveScriptChanges", () => {
        if ($rootScope.changedFields.get("scriptmeta")) {
          Scripts.updateScriptMeta($scope.scriptmeta, () => {
            Scripts.markSaved("scriptmeta");
          });
        }
        if ($rootScope.changedFields.get("scriptmeta.titles")) {
          $scope.titles[0].SCRIPT_ID = $scope.scriptmeta.ID;
          Scripts.updateScriptTitle($scope.titles[0], (data) => {
            if (data) {
              $scope.titles[0].ID = data.NEWID;
            }
            Scripts.markSaved("scriptmeta.titles");
          });
        }
      });

      System.loadSpecialities((data) => {
        $scope.specialities = data;
      });

      $scope.$on("$destroy", scriptListener);

      $scope.unpublish = () => Scripts.updateScriptStatus($scope.scriptmeta.ID, "test", (data) => {
        $scope.scriptmeta.STATUS = data.STATUS;
      });
    },
  ]);
